export enum ChartType {
  Doughnut = 'doughnut',
}
